//@ts-nocheck
import React from "react";
import { withRouter } from "react-router";
import withAlertBox from "../../../../components/src/withAlertBox.Web";
import withToast from "../../../../components/src/withSnackBar.Web";
import withLoader from "../../../../components/src/withLoader.Web";
import withDialog from "../../../../components/src/withDialog.web";
import withConfirmBox from "../../../../components/src/withConfirmBox.Web";
import QuestionCard from "./layout/QuestionCard.web";
import OptionList from "./layout/OptionList.web";
import StepFooter from "./layout/StepFooter.web";

class SavingStep extends React.Component {
  async componentDidMount() {
    this.props.getQuestionAndOptionsByStepNo("8.2.1");
  }
  render() {
    const selection = this.props.savingSelection || [];
    return (
      <>
        <QuestionCard
          title={this.props?.stepContent?.description}
          hint="Select any that apply"
        >
          <OptionList
            options={this.props?.stepContent?.options?.data}
            selected={selection}
            multiple
            onSelect={this.props.setSavingSelection}
          />
        </QuestionCard>
        <StepFooter
          onBack={this.props.handleBack}
          onNext={this.props.handleNext}
          nextDisabled={selection.length === 0}
        />
      </>
    );
  }
}
const SavingStepWithRouter = withRouter(SavingStep);
const SavingStepAlertBox = withAlertBox(SavingStepWithRouter);
const SavingStepLoader = withLoader(SavingStepAlertBox);
const SavingStepToast = withToast(SavingStepLoader);
const SavingStepWithDialog = withDialog(SavingStepToast);

export default withConfirmBox(SavingStepWithDialog);
